"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EventDispatcher = _interopRequireDefault(require("../../../event/EventDispatcher"));

var _DOM = _interopRequireDefault(require("../../../display/DOM"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var KeyObserver =
/** @class */
function (_super) {
  __extends(KeyObserver, _super);

  function KeyObserver() {
    var _this = _super.call(this) || this;

    _this.keyHandler = function (e) {
      _this.listenForKeys(e);
    };

    return _this;
  }

  KeyObserver.prototype.start = function () {
    (0, _DOM.default)(document).on('keyup keypress', this.keyHandler);
  };

  KeyObserver.prototype.stop = function () {
    (0, _DOM.default)(document).off('keyup keypress', this.keyHandler);
  };

  KeyObserver.prototype.listenForKeys = function (e) {
    var event = e.type;
    var key = (e.key || '').toLowerCase();
    this.trigger(event, {
      event: event,
      key: key
    });

    if (event === 'keyup') {
      if (key === 'escape' || key === 'esc' || e.keyCode === 27) {
        this.trigger('escape');
      } else if (key === 'enter') {
        this.trigger('enter');
      }
    }
  };

  return KeyObserver;
}(_EventDispatcher.default);

var _default = KeyObserver;
exports.default = _default;
module.exports = exports.default;